<template>
    <div 
        class="row-with-label" 
        :class="{ 'is-column': isColumn, 'is-row': !isColumn}"
    >
        <!-- 힌트 아이콘(#hint)은 라벨 상자 안에 인라인으로 그린다 — 별도 형제 칸을 추가하면
             힌트가 없는 행의 DOM/폭까지 바뀌어 이 컴포넌트를 쓰는 다른 화면에 영향이 번진다
             (실사고: 빈 예약 칸이 행 최소폭을 키워 Step3 카드가 중앙정렬+overflow:hidden으로
             좌우 잘림). 구조는 힌트 유무와 무관하게 동일해야 한다. 라벨이 80px보다 길어
             아이콘이 잘리는 폼은 이 컴포넌트를 고치지 말고 해당 폼에서 label-width prop으로
             라벨 폭을 넓혀 해결한다(폼 내 전 행 동일 적용 → 정렬 유지). -->
        <label
            v-if="labelTitle"
            :class="labelTitle ? 'label-column' : ''"
            :style="getLabelStyle"
        >
            <p>{{ labelTitle }}<span class="required-span" v-if="isRequired"/><slot name="hint" /></p>
        </label>
        <label
            v-else
            :class="labelKey ? 'label-column' : ''"
        >
            <p>{{ computedTitle }}<span class="required-span" v-if="isRequired"/><slot name="hint" /></p>
            <p v-if="targetLanguage" class="translated-text">{{ computedTranslatedTitle }}</p>
        </label>
        <input-and-error
            :class="class"
            :hasError="hasError"
            :errorMessage="errorMessage"
        >
            <slot />
        </input-and-error>
    </div>
</template>
<script>

import InputAndError from './InputAndError.vue';
export default {
    components: {
        InputAndError,
    },
    props: {
        labelTitle: {
            type: String,
        },
        labelWidth: {
            type: Number,
            default: 80,
        },
        isRequired: {
            type: Boolean,
        },
        class: {
            type: String,
        },
        hasError: {
            type: Boolean,
        },
        errorMessage: {
            type: String,
        },
        isColumn: {
            type: Boolean,
        },

        // 번역 관련
        labelKey: {
            type: String,
        },
        targetLanguage: {
            type: String,
        },
        labelVerticalAlign: {
            type: String,
            default: 'center'
        },
        labelWidth: {
            type: String,
            default: '80px',
        },
    },
    computed: {
        computedTitle() {
            if(!this.labelKey) return '';
            return this.$t(this.labelKey);
        },
        computedTranslatedTitle() {
            return this.$t(this.labelKey, this.targetLanguage);
        },
        getBaseLabelStyle() {
            if (this.labelTitle || this.labelKey) {
                return {
                    [this.labelVerticalAlign ? 'justify-content' : 'align-items']: this.labelVerticalAlign || 'center'
                }
            }
            return {}
        },
        getLabelStyle() {
            // isColumn이 true일 때는 빈 스타일을 반환하고, false일 때만 스타일 적용
            if (this.isColumn) {
                return {}; // isColumn일 때 빈 스타일
            }
            
            console.log(this.labelWidth);
            return {
                ...this.getBaseLabelStyle, // 기존 스타일 유지
                width: this.labelWidth, // width 추가
                flex: `0 0 ${this.labelWidth}`,
            };
        },
    },
};
</script>
<style lang="scss" scoped>
$Gray-5: #F7F8F8;
$Gray-10: #F1F2F3;
$Gray-20: #E8EBED;
$Gray-30: #DDE0E4;
$Gray-40: #C7CCD1;
$Gray-50: #ACB2B9;
$Gray-60: #8D939A;
$Gray-70: #6e747c;
$Gray-80: #4B5158;
$Gray-90: #2F3337;
$Gray-100 : #17191C;
$Yellow: #ffe414;
$Blue : #278AEC;
$SkyBlue : #E1F0FF;

.row-with-label {
    width: 100%;
    display: flex;
    gap: 10px;
    justify-content: start;
    align-items: start;
    .label-column {
        flex-direction: column;
        justify-content: center;
        height: 100%;
    }

    label {
        width: 80px;
        flex: 0 0 80px;
        margin-bottom: 0px;
        margin-left: 0px;
        display: flex;
        gap: 3px;
        color: $Gray-90;
        font-size: 15px;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: 400;
        p {
            margin-bottom: 0;
            display: flex;
            gap: 3px;
        }
        .required-span {
            display: inline-block;
            width: 6px;
            height: 6px;
            background-color: #FB574B;
            border-radius: 100%;
            margin-bottom: 10px;
        }
    }

}

.row-with-label.is-column {
    display: flex;
    flex-direction: column;
    gap: 8px;
    label {
      flex: auto;
      gap: 0;
      p {
        min-height: 20px;
      }
    }
    margin-bottom: 10px;
} 
</style>

